import { login } from './login';
import { loginOrRegister } from './loginOrRegister';
import { getPayments } from './getPayments';
import { getAddresses } from './getAddresses';
import { getEmailStatus } from './getEmailStatus';
import { resendEmailVerification } from './resendEmailVerification';
import { consumeVerificationCode } from './consumeVerificationCode';
import { getMedcards } from './getMedcards';
import { removePayment } from './removePayment';
import { addAddress } from './addAddress';
import { updateUserProfile } from './updateUserProfile';
import { updateAddress } from './updateAddress';
import { removeAddress } from './removeAddress';
import { addPayment } from './addPayment';
import * as Client from './client';
import { updatePayment } from './updatePayment';

export const AccountAPI = {
    login,
    loginOrRegister,
    getPayments,
    getAddresses,
    getEmailStatus,
    removePayment,
    resendEmailVerification,
    consumeVerificationCode,
    getMedcards,
    addAddress,
    updateUserProfile,
    updateAddress,
    removeAddress,
    addPayment,
    Client,
    updatePayment,
};
